import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CalendarIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 6H18V8H7V6ZM7 9V18H18V9H7ZM6 19V5H19V19H6ZM11 11H12V12H11V11ZM14 11H13V12H14V11ZM15 11H16V12H15V11ZM10 13H9V14H10V13ZM9 15H10V16H9V15ZM12 13H11V14H12V13ZM11 15H12V16H11V15ZM14 13H13V14H14V13ZM13 15H14V16H13V15ZM16 13H15V14H16V13Z"
      fill="currentColor"
    />
  </svg>,
  'Calendar'
);
